import script from "./TagsDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagsDetailsView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521b09e5"]])

export default __exports__